import * as React from 'react';
import styled from 'styled-components';
import { Desktop, Mobile } from 'elc-layouts';
import { DesktopFilters } from '../../../internal/views/product-filters/DesktopFilters';
import { Column } from 'elc-grid';
import { ContentSpacing, breakpoint, Breakpoints } from 'elc-base-theme';
import { translate } from 'elc-service';
import { observer } from 'mobx-react';
import { classes } from '../../utils/Classes';
import { FilterSet } from '../../domain/entities/FilterSet';
import { MobileFilters } from '../product-filters/MobileFilters';
import { filtersConfig, FILTER_TYPES, IFilterConfig } from '../product-filters/FiltersConfig';

export interface IProductGridFiltersTranslation {
    resultsLabel: string;
}

export interface IProductGridFilters {
    productsNumber: number;
    filterSets: FilterSet[];
    appliedFilters: FilterSet[];
    totalAppliedFilters?: number;
    translations?: IProductGridFiltersTranslation;
    filtersDisplayType?: FILTER_TYPES;
}

const StyledResultsColumn = styled(Column)`
    margin-top: ${ContentSpacing.space16};
    margin-bottom: ${ContentSpacing.space24};
    display: flex;
    ${breakpoint('desktop')`
        display: none;
    `};
`;

@translate(['resultsLabel'])
@observer
export class ProductGridFilters extends React.Component<IProductGridFilters> {
    render() {
        const { resultsLabel } = this.props.translations as IProductGridFiltersTranslation;
        const styledMobileResultsClassnames = classes('mobile-attribute-filters-results');
        const styledMobileResultsLabelClassnames = classes(
            'mobile-attribute-filters-results-label'
        );
        let config: IFilterConfig = filtersConfig[this.props.filtersDisplayType as FILTER_TYPES];

        if (!config) {
            config = filtersConfig[FILTER_TYPES.CHIPS];
        }

        return (
            <>
                <Desktop minWidth={Breakpoints.desktop}>
                    {() => (
                        <DesktopFilters
                            filterSets={this.props.filterSets}
                            appliedFilters={this.props.appliedFilters}
                            productsNumber={this.props.productsNumber}
                            config={config}
                        />
                    )}
                </Desktop>
                <Mobile maxWidth={Breakpoints.desktop - 1}>
                    {() => (
                        <>
                            <MobileFilters
                                filterSets={this.props.filterSets}
                                appliedFilters={this.props.appliedFilters}
                                productsNumber={this.props.productsNumber}
                                totalAppliedFilters={this.props.totalAppliedFilters}
                            />
                            <StyledResultsColumn xs={12} className={styledMobileResultsClassnames}>
                                <div className={styledMobileResultsLabelClassnames}>
                                    {this.props.productsNumber} {resultsLabel}
                                </div>
                            </StyledResultsColumn>
                        </>
                    )}
                </Mobile>
            </>
        );
    }
}
